import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router";
import PropTypes from "prop-types";

import { selectIsLoading, selectAllCustomTables } from "@ROM/CustomTables/selectors";
import { companyAdminUrl } from "@ROM-utils/urlHelpers";
import Section from "@ROM-components/common/Section";
import { customTablesShowBreadcrumbs } from "@ROM/CompanyAdmin/utils";
import CustomTableRowForm from "@ROM/CustomTableRows/components/Form";

const Page = ({ customTableId }) => {
  const isLoading = useSelector(selectIsLoading);
  const customTables = useSelector(selectAllCustomTables);
  const table = customTables.find((item) => item.id === customTableId);

  const breadcrumbs = customTablesShowBreadcrumbs(table, [{ label: "New Content", active: true }]);

  if (isLoading) {
    return null;
  }

  if (!table) {
    return <Redirect to={companyAdminUrl()} />;
  }

  return (
    <Section breadcrumbs={breadcrumbs}>
      <CustomTableRowForm table={table} />
    </Section>
  );
};

Page.propTypes = {
  customTableId: PropTypes.string.isRequired,
};

export default Page;
